export default __webpack_public_path__ + "static/media/209.7686e907.jpg";